module.exports = __webpack_public_path__ + "img/kayak_1413_5.c4271f5f.jpg";